import {createFileRoute, useNavigate} from "@tanstack/react-router"
import {useGetCurrentMonthQuery} from "@/api/endpoints/other.ts";
import {useEffect, useMemo} from "react";

export const Route = createFileRoute("/_mainLayout/revshare-pools/")({
  component: RouteComponent,
});

function RouteComponent() {
  const {data: currentMonthUtc} = useGetCurrentMonthQuery()

  const [month, year] = useMemo(()=>{
    //todo make current month <> undefined
    let m = currentMonthUtc?.month ?? 7;
    let y = currentMonthUtc?.year ?? 2025;
    if (m === 12){
      y = y + 1;
      m = 1;
    } else {
      m = m + 1;
    }

    return [m, y]
  }, [currentMonthUtc])

  const navigate = useNavigate()
  useEffect(() => {
    if (!currentMonthUtc) return;
    navigate({to: '/revshare-pools/' + year + '/' + month})
  }, [currentMonthUtc]);

  return (
    <></>
  );
}
